import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconCalendarRoundLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.624 3.999a1 1 0 0 1 1 1v1.626h6.752V4.999a1 1 0 1 1 2 0v1.626h.626a2 2 0 0 1 2 2v9.378a2 2 0 0 1-2 2H5.998a2 2 0 0 1-2-2V8.625a2 2 0 0 1 2-2h.626V4.999a1 1 0 0 1 1-1ZM18.002 11V8.625H5.998V11h12.004ZM5.998 13h12.004v5.003H5.998V13Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconCalendarRoundLine);
export default Memo;
